import * as React from 'react';
import {ReelsMatrixSymbol} from './ReelsMatrixSymbol';
import {DisplayObjectList} from './DisplayObjectList';
import {Texture} from 'pixi.js';

export type ReelsMatrixProps = {
    matrix: number[][];
    symbolsTexturesByID: {[id: number]: Texture;};
    onClickSymbol: (symbolId: number, reelIndex: number, rowIndex: number) => void;
    onRightClickSymbol: (symbolId: number, reelIndex: number, rowIndex: number) => void;
    selectedCell?: {reelIndex: number; rowIndex: number;};
};

export class ReelsMatrix extends React.Component<ReelsMatrixProps> {
    protected getSymbolView(symbolID: number, reelIndex: number, rowIndex: number): JSX.Element {
        const image = this.props.symbolsTexturesByID[symbolID];
        const {selectedCell} = this.props;

        return <ReelsMatrixSymbol
            selected={selectedCell && selectedCell.rowIndex === rowIndex && selectedCell.reelIndex === reelIndex}
            key={`${reelIndex}-${rowIndex}-${symbolID}`}
            image={image}
            onClick={this.props.onClickSymbol.bind(this)}
            onRightClick={this.props.onRightClickSymbol.bind(this)}
            id={symbolID}
            reel={reelIndex}
            row={rowIndex}
        />;
    }

    protected getReelView(reel: number[], reelIndex: number): JSX.Element {
        return (
            <DisplayObjectList gapBetweenChildren={20} key={reelIndex.toString()}>
                {reel.map( (id, rowIndex) => this.getSymbolView(id, reelIndex, rowIndex))}
            </DisplayObjectList>
        );
    }

    render(): JSX.Element {
        const {matrix} = this.props;

        return (
            <DisplayObjectList direction={'row'} gapBetweenChildren={20} >
                {matrix.map(this.getReelView.bind(this))}
            </DisplayObjectList>
        );
    }
}
